export const GET_GLOBAL_LIBRARY_START = 'GET_GLOBAL_LIBRARY_START';
export const GET_GLOBAL_LIBRARY_SUCCESS = 'GET_GLOBAL_LIBRARY_SUCCESS';
export const GET_GLOBAL_LIBRARY_FAILED = 'GET_GLOBAL_LIBRARY_FAILED';
export const GET_MY_LIBRARY_START = 'GET_MY_LIBRARY_START';
export const GET_MY_LIBRARY_SUCCESS = 'GET_MY_LIBRARY_SUCCESS';
export const GET_MY_LIBRARY_FAILED = 'GET_MY_LIBRARY_FAILED';
export const DELETE_SINGLE_TEMPLATE_START = 'DELETE_SINGLE_TEMPLATE_START';
export const DELETE_SINGLE_TEMPLATE_SUCCESS = 'DELETE_SINGLE_TEMPLATE_SUCCESS';
export const DELETE_SINGLE_TEMPLATE_FAILED = 'DELETE_SINGLE_TEMPLATE_FAILED';
export const DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_START = 'DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_START';
export const DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_SUCCESS = 'DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_SUCCESS';
export const DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_FAILED = 'DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_FAILED';

export const getGlobalLibraryStart = () => ({
  type: GET_GLOBAL_LIBRARY_START
});

export const getGlobalLibrarySuccess = (data) => ({
  type: GET_GLOBAL_LIBRARY_SUCCESS,
  data
});

export const getGlobalLibraryFailed = () => ({
  type: GET_GLOBAL_LIBRARY_FAILED
});

export const getMyLibraryStart = () => ({
  type: GET_MY_LIBRARY_START
});

export const getMyLibrarySuccess = (data) => ({
  type: GET_MY_LIBRARY_SUCCESS,
  data
});

export const getMyLibraryFailed = () => ({
  type: GET_MY_LIBRARY_FAILED
});

export const deleteSingleTemplateStart = () => ({
  type: DELETE_SINGLE_TEMPLATE_START
});

export const deleteSingleTemplateSuccess = (id, data) => ({
  type: DELETE_SINGLE_TEMPLATE_SUCCESS,
  id,
  data
});

export const deleteSingleTemplateFailed = () => ({
  type: DELETE_SINGLE_TEMPLATE_FAILED
});

export const downloadGlobalLibraryTemplateStart = () => ({
  type: DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_START
});

export const downloadGlobalLibraryTemplateSuccess = (data, templateId) => ({
  type: DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_SUCCESS,
  data,
  templateId
});

export const downloadGlobalLibraryTemplateFailed = (error) => ({
  type: DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_FAILED,
  error
});
